// Cloudflare Turnstile CAPTCHA Plugin
const Turnstile = {
    install(Vue) {
        Vue.prototype.$turnstile = {
            siteKey: null,
            loaded: false,
            widgetId: null,

            init(siteKey) {
                if (!siteKey || this.loaded) return;
                this.siteKey = siteKey;

                const script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.loaded = true;
                };
                document.head.appendChild(script);
            },

            render(containerId, callback) {
                if (!this.siteKey) {
                    console.warn("Turnstile Site Key not set.");
                    return;
                }

                // Wait for script to load
                const tryRender = () => {
                    if (window.turnstile) {
                        // Cleanup any existing widget
                        const container = document.getElementById(containerId);
                        if (container) {
                            container.innerHTML = '';
                        }

                        this.widgetId = window.turnstile.render('#' + containerId, {
                            sitekey: this.siteKey,
                            theme: 'dark',
                            callback: (token) => {
                                if (callback) callback(token);
                            },
                            'error-callback': () => {
                                console.error('Turnstile error');
                                if (callback) callback(null);
                            }
                        });
                    } else {
                        setTimeout(tryRender, 100);
                    }
                };

                tryRender();
            },

            getToken() {
                if (window.turnstile && this.widgetId !== null) {
                    return window.turnstile.getResponse(this.widgetId);
                }
                return null;
            },

            reset() {
                if (window.turnstile && this.widgetId !== null) {
                    window.turnstile.reset(this.widgetId);
                }
            }
        };
    }
};

export default Turnstile;
